export const selectFrontUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return "http://localhost:3000";
    case "prod":
      return "https://geequip.sistemasgap.com.br";
    default:
      return "http://localhost:3000";
  }
};
